import { useState, useRef, useEffect } from 'react';
import './MfaDialog.css';

interface MfaDialogProps {
  botName: string;
  onSubmit: (otp: string) => void;
  onCancel: () => void;
}

export function MfaDialog({ botName, onSubmit, onCancel }: MfaDialogProps) {
  const [otp, setOtp] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleSubmit = () => {
    if (otp.length === 6) onSubmit(otp);
  };

  return (
    <div className="mfa-overlay" onClick={onCancel}>
      <div className="mfa-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="mfa-dialog__title">ProStocks MFA</div>
        <div className="mfa-dialog__subtitle">
          Enter 6-digit OTP to start <strong>{botName}</strong>
        </div>
        <input
          ref={inputRef}
          className="mfa-dialog__input"
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={6}
          placeholder="000000"
          value={otp}
          onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
          onKeyDown={(e) => { if (e.key === 'Enter') handleSubmit(); if (e.key === 'Escape') onCancel(); }}
        />
        <div className="mfa-dialog__actions">
          <button className="mfa-dialog__btn mfa-dialog__btn--cancel" onClick={onCancel}>Cancel</button>
          <button className="mfa-dialog__btn mfa-dialog__btn--submit" disabled={otp.length !== 6} onClick={handleSubmit}>Start Bot</button>
        </div>
      </div>
    </div>
  );
}
